export default __webpack_public_path__ + "static/media/Sb.d5494fb5.jpg";